// import React from 'react';

// const CustomSelect = ({ label, error, options, onChange, ...props }) => {
 

//   return (
//     <div className="mb-4 m-2">
//       <label className="block text-sm font-medium text-gray-700" htmlFor={props.id || props.name}>
//         {label}
//       </label>
//       <select
//         {...props}
//         onChange={onChange}
//         className={`mt-1 block w-full rounded-md border-gray-300 shadow-sm`}
//       >
//         {options.map((option) => (
//           <option key={option.value} value={option.value}>
//             {option.label}
//           </option>
//         ))}
//       </select>
//       { error && (
//         <div className="text-red-500 text-sm mt-1">{error}</div>
//       )}
//     </div>
//   );
// };

// export default CustomSelect;

import React from 'react';

const CustomSelect = ({ label, error, isRequired, helperText, options, onChange, otherClass, ...props }) => {
  const isFirstDisabled = true; // Flag to disable the first option

  return (
    <div className="mb-4 m-2">
      <label className="block text-sm font-medium text-gray-700" htmlFor={props.id || props.name}>
        {label}
        {isRequired && <span className="text-red-500">*</span>}
      </label>
      <select
        {...props}
        onChange={onChange}
        className={`mt-1 block w-full border border-black shadow-sm ${error ? '!border-red-500' : ''} ${otherClass}`}
      >
        <option value="" disabled={isFirstDisabled} hidden={isFirstDisabled} selected={isFirstDisabled}>
          {/* Display the first option without selecting it */}
          {isFirstDisabled ? options[0].label : ''}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      { error && helperText && (
        <div className="text-red-500 text-sm mt-1">{helperText}</div>
      )}
    </div>
  );
};

export default CustomSelect;



